import {includes} from 'lodash';

export const getNewCurrencyPair = (currencyPairs, i18nString, locale) => {
    const baseLabel = i18nString('dbm.currency.base', locale);
    const counterLabel = i18nString('dbm.currency.counter', locale);
    currencyPairs.push({
        base: {
            label: baseLabel,
            isoString: baseLabel
        },
        counter: {
            label: counterLabel,
            isoString: counterLabel
        }
    });

    return currencyPairs
};

export const getCurrencyByIsoString = (currencies, ccyIso) => {
    return currencies.filter(ccy => ccy.isoString === ccyIso)[0]
};

export const getCcyPairsAsParameters = (pairs) => {
  return pairs.map(pair => {
 
    const base = pair.base?.isoString || pair.base || "";
    const counter = pair.counter?.isoString || pair.counter || "";
 
    return `${base}_${counter}`;
  });
};

export const canSwapCcyPair = (ccyPair, currencies) => {
    // Guard against null/undefined ccyPair from URL params
    if (typeof ccyPair !== 'string' || !ccyPair) {
        return false;
    }

    // the pair can only be swapped if the current counter currency is also a base currency
    const counter = ccyPair.split('_')[1];
    const baseCcys = currencies
        .filter(ccy => ccy.status === "BASE")
        .map(ccy => ccy.isoString);
    return includes(baseCcys, counter);

};

export const getCcyPairsFromParameters = (ccyPairsParameters = [], currencies = []) => {
    if (!ccyPairsParameters) {
        return [];
    }
    const ccyPairs = [];
    ccyPairsParameters.forEach(ccyPair => {
        const ccys = ccyPair.split('_');
        const base = getCurrencyByIsoString(currencies, ccys[0]);
        const counter = getCurrencyByIsoString(currencies, ccys[1]);
        if (base && counter) {
            ccyPairs.push({ base, counter });
        }
    });
    return ccyPairs;
};